export const base = process.env.REACT_APP_BASE_URL;
export const sanctum = "/sanctum/csrf-cookie";
